import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import {
  requiredFileIf,
  requiredFiles,
} from '../../../useValidateQuestionnaire';

import {
  NonUsTrustStateValues,
  TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

// predicate:
// 'Displayed in case the user selects "Yes" to the "I have a Non-US Trust" question in the general tab.',

export const fields: IBaseField<
  | keyof NonUsTrustStateValues
  | keyof TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow
>[] = [
  {
    name: 'nameOfTrust',
    subLabel: () => (
      <p>
        Enter the name of the trust that was organised in a foreign country and
        subject to that country's law and court is a foreign trust.
      </p>
    ),
    label: 'Name of trust',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Name of trust',
  },
  {
    name: 'streetAddress',
    label: 'Street Address',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'stateOrProvince',
    label: 'State or Province',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },
  {
    name: 'postCode',
    label: 'Post Code',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Enter...',
  },

  {
    name: 'country',
    label: 'Country',
    type: 'country',
    placeholder: 'Select Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'dateOfCreation',
    label: 'Date of Creation',
    subLabel: () => (
      <p>
        A trust can be created either by a deed of trust or a declaration of
        trust. Enter the date when the deed is signed to create a trust.
      </p>
    ),
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },
  {
    name: 'endOfTaxYear',
    label: 'End of Tax Year',
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },

  {
    name: 'countryOfIncorporation',
    label: 'Country of Incorporation',
    type: 'country',
    placeholder: 'Select Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTrustInstrument',
    label: 'Please upload Trust Instrument',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTrustBalanceSheet',
    label: 'Please upload Trust balance sheet',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTrustIncomeStatement',
    label: 'Please upload Trust Income Statement',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'haveYouFiledForm3520A',
    label: 'Have you filed form 3520-A?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'whenDidYouLastFile3520A',
        label: 'When did you last file 3520-A?',
        type: 'select',
        options: [
          {
            label: '2019',
            value: '2019',
          },
          {
            label: '2018',
            value: '2018',
          },
          {
            label: '2017',
            value: '2017',
          },
          {
            label: 'Never',
            value: 'Never',
          },
          {
            label: 'Enter Manually',
            value: 'Enter Manually',
          },
        ],
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'whichYear',
            label: 'Which year?',
            type: 'text',
            predicate: (value) => value === 'Enter Manually',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
    ],
  },
  {
    name: 'didYouTransferAssetsOrCashToTheTrustInYear',
    label: 'Did you transfer assets or cash to the Trust in {year}?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'howMuchDidYouTransfer',
        label: 'How much did you transfer?',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'pleaseProvideDetails',
        label: 'Please provide details',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
    ],
  },
  {
    name: 'areThereOtherUsOwnersForTheTrust',
    label: 'Are there other US owners for the trust?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'pleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow',
        label:
          'Please provide details about all US owners (including yourslf) of the trust in the table below',
        type: 'fieldArray',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: { name: null, ssn: null, address: null },
        dependencies: [
          {
            name: 'name',
            label: 'Name',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'ssn',
            label: 'SSN',
            type: 'maskedInput',
            mask: '999-99-9999',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'address',
            label: 'Address',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
        ],
      },
    ],
  },
  {
    name: 'didYouReceivedACashOrPropertyDistributionFromTheTrust',
    label: 'Did you received a cash or property distribution from the Trust?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'pleaseUploadDocumentReportingTheDistribution',
        label: 'Please upload document reporting the distribution',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
